import { render, staticRenderFns } from "./ChargeAgent.vue?vue&type=template&id=23798c0c&scoped=true&"
import script from "./ChargeAgent.vue?vue&type=script&lang=js&"
export * from "./ChargeAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23798c0c",
  null
  
)

export default component.exports